<template>
    <div class="relative z-10">

        <button @click.prevent="toggleSearch" class="nav-link focus:outline-none">
            <slot></slot>
        </button>

        <div class="search-box shadow-md text-left">

            <form action="/" method="get" class="p-2">

                <button type="button" @click.prevent="closeSearch" class="float-right focus:outline-none text-pink hover:text-blue">
                    <i><svg class="h-12 w-12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 9"><path fill="currentColor" fill-rule="evenodd" d="M4.5 5.402l-3.403 3.41A.642.642 0 1 1 .188 7.9l3.403-3.409L.188 1.083A.645.645 0 0 1 .204.189a.642.642 0 0 1 .893-.016L4.5 3.582 7.903.172a.642.642 0 0 1 .893.017c.245.245.252.64.016.894L5.409 4.492l3.403 3.409A.645.645 0 0 1 8.358 9a.642.642 0 0 1-.455-.189L4.5 5.402z"></path></svg></i>
                </button>

                <div class="mb-1">
                    <label class="block text-grey text-xs mb-1" for="s">
                        Search for...
                    </label>
                    <input class="search-input shadow appearance-none border rounded w-full text-grey leading-tight focus:outline-none focus:shadow-outline" id="s" name="s" type="search" v-model="model">
                </div>

                <button :disabled="!model" class="search-button inline-block bg-blue px-2 text-white no-underline leading-loose hover:bg-pink capitalize" type="submit">
                    Search
                </button>

            </form>
        </div>

    </div>
</template>

<script>
    export default {

        name: 'SidebarSearch',

        props: ['query'],

        data() {
            return {
                model: this.query,
            }
        },

    }
</script>

<style scoped>
    .search-box {
        position: absolute;
        top: 130%;
        right: -15px;
        width: 320px;
        background: #fff;
    }

    .search-input {
        padding: 10px 10px;
    }

    .search-button {
        padding-top: 5px;
        padding-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// web/app/themes/giles/resources/js/components/SidebarSearch.vue